import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Link } from 'react-router-dom';
import formatDateToBR from '../../../utils/formatDateToBR';
// import { NEW_NEWS } from '../actions/NewsActions';
import { newsText } from '../helpers/newsSeo';
import NewsImage from './NewsImage';

function NewsHomeColumnComponent({ dataMostRelevantNews, isVisible, countNewsView }) {
    useEffect(() => {
        if (isVisible) {
            dataMostRelevantNews.forEach((news) => {
                countNewsView({
                    newsId: news.id,
                    timestamp: Date.now(),
                });
            });
        }
    }, [isVisible, countNewsView, dataMostRelevantNews]);

    return (
        <div>
            {dataMostRelevantNews.map((news, index) => (

                <div key={news.id} className="box">
                    <Link
                        to={`/noticias/${news.slug}`}
                        title={`Saiba mais sobre ${news.title}`}
                        className="tw-grid tw-items-center lg:tw-gap-10 tw-grid-cols-1 lg:tw-grid-cols-2"
                    >

                        <div>
                            <p className="alternativeFontSize tw-text-gray-500 data-publicacao">
                                {formatDateToBR(news.date)}
                            </p>

                            <h3 className="tw-mb-3 limitText2">
                                {news.title}
                            </h3>

                            <p className="tw-my-3 limitText2">
                                {newsText(news.content)}
                            </p>
                        </div>

                        <div>
                            <NewsImage news={news} priority={index === 0} sizes="(min-width: 1280px) 260px, (min-width: 1024px) 22vw, (min-width: 768px) 45vw, calc(100vw - 40px)" />
                        </div>

                    </Link>
                </div>
            ))}
        </div>
    );
}

NewsHomeColumnComponent.propTypes = exact({
    dataMostRelevantNews: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            date: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
            imageNew: PropTypes.string,
            imageUrl: PropTypes.string,
            content: PropTypes.string,
        }),
    ).isRequired,
    breakpointReducer: PropTypes.shape({
        serverBreakPoints: PropTypes.shape({
            isExtraLarge: PropTypes.bool,
            isLarge: PropTypes.bool,
            isMedium: PropTypes.bool,
        }).isRequired,
    }).isRequired,
    isVisible: PropTypes.bool,
    countNewsView: PropTypes.func.isRequired,
    // maxContentLength: PropTypes.number,
});

export default NewsHomeColumnComponent;
